import React from 'react'

const Title = ({Name,Icon}) => {
  return (
    <div className='admin_title_container'>
      <div className='admin_title_icon'>
        <Icon fill='##2a2a2a' />
      </div>
      <div className='admin_title_name'>
        <h6>{Name}</h6>
      </div>
    </div>
  )
}

export default Title
